/* eslint-disable no-loop-func */
/* eslint-disable no-undef */
import React, { useState, useEffect } from "react";

//*MUI
import { Box, Modal, Typography, Popover } from "@mui/material";

//*files
import cssClasses from "./DirectAllotment.module.css";
import Button from "../../../../Subcomponents/Button";

import ThreeDotsMenu from "../../../../Subcomponents/ThreeDotsMenu";
import DropDown from "../../../../Subcomponents/DropDown";

import Close from "../../../Icons/Close";

//*Redux
import { useDispatch, useSelector } from "react-redux";
import action from "../../../../Redux Store/actions";
import {
  AddPaymentData,
  getAllInventoryStatusFromTable,
  getAllLeadsForSearch,
  getAllLeadsForSearchName,
  getAllLeadsForSustenance,
  getLeadDetailsForSustenance,
  getLeadDetailsFromInventory,
  getLeadInfo,
  getProjectByProjectName,
  getUnitByUnitNo,
  getUnitCancellation,
  RemoveLeadFromInterestQueue,
  UpdateLeadIdToInventory,
} from "../../../../Services/SustenanceService";
import { Fragment } from "react";
import { errorTost, infoTost, successTost } from "../../../../Services/Toast";
import { useParams, useNavigate } from "react-router-dom";

import {
  getAlotSustananceGlobalUnitAvailable,
  getAlotSustananceGlobalRoute,
  getAlotSustenanceLead,
  getAlotEventGlobalLeadAvailable,
} from "../../../../Services/StoredSessionData";
import {
  AddUnitInterest,
  allotUnit,
  checkForInventoryStatus,
  getAllInventoryStatus,
  getAllotedLeadFromPaymentsTable,
  getAllotmentPayment,
  getAllotmentPaymentByUnit,
  getAllUnitInterests,
  getInventoryStatus,
  getLeadFromAllotment,
  getProjectPricingByUnitId,
  getUnitStatus,
  InsertIntoAllotmentTable,
  updateLeadStatusForAllotment,
  UpdateUnitStatus,
} from "../../../../Services/Event";
import Datagrid from "../../../../Subcomponents/Datagrid";
import { addLeadLogs, updateLeadAllStatus } from "../../../../Services/Lead";
import LeadStatusChip from "../../../../Subcomponents/LeadStatusChip";
import Dot from "../../../Icons/Dot";
import { dismissLoader, presentLoader } from "../../../../Services/loader";
import { supabase } from "../../../../supabaseClient";
import axios from "axios";
import LoaderWithMsg from "../../../../Subcomponents/LoaderWithMsg";
import { debounce, uniq, uniqBy } from "lodash";
import CustomAutoComplete from "../../../../Subcomponents/CustomAutoComplete";
import PaymentModal from "../../../../Modals/PaymentModal/PaymentModal";
import {
  getAllPaymentPlans,
  getAllPaymentPlansByProjectId,
  getAllPricingPlansByProjectId,
} from "../../../../Services/PaymentPlans";
import { insertInventoryLogs, insertTransactionLogs, updateAllotmentPayment } from "../../../../Services/AllAllotments";
import {
  getActiveLaunchInventory,
  getFutureLaunchInventory,
} from "../../../../Services/FastBooking";
import { CheckBookingAmounts, getPaymentPlansPriceFromServer } from "../../../../Services/Project";
import { updateAllotmentTransactionsForTrnsUpdate } from "../../../../Services/ChangeUnit";
import { sendMailTo } from "../../../../Services/SmsService";
import { bucketingForChangeUnit } from "../../../../Services/PaymentApi";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getInventoryTypeId } from '../../../../Services/Inventory';
const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-Content",
  height: "fit-Content",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
};

function DirectAllotment() {
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  //*Modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { unitNo, wingName, projectId } = useParams();

  //*unit-interest-table
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [ProjectData, setProjectData] = useState([]);
  const [UnitInterestData, setUnitInterestData] = useState([]);
  const [mergeIdData, setMergeIdData] = useState(false);
  const [OnHoldData, setOnHoldData] = useState(false);
  const [OnHoldDetails, setOnHoldDetails] = useState([]);
  const [mergeID, setMergeID] = useState("");
  const [FloorRiseValue, setFloorRiseValue] = useState(0);
  const [plcValue, setPlcValue] = useState(0);
  const [Unit1, setUnit1] = useState("");
  const [Unit2, setUnit2] = useState("");
  const [Unit1Name, setUnit1Name] = useState("");
  const [priceNotAdded, setPriceNotAdded] = useState(false);
  const [afterCancelUnitPrice, setAfterCancelUnitPrice] = useState(false);
  const [Unit2Name, setUnit2Name] = useState("");
  const [NotForSaleChip, setNotForSaleChip] = useState(false);
  const [BookingAmountData, setBookingAmountData] = useState([]);

  //*DA
  const steps = [
    {
      title: "Lead Details",
      text: "",
    },
    {
      title: "Payment Details",
      text: "",
    },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [loaderMsg, setLoaderMsg] = useState("");

  const [SearchData, setSearchData] = useState(false);
  const [SearchValue, setSearchValue] = useState("");
  const [ChipStyle, setChipStyle] = useState(null);

  //*Lead-Info
  const [LeadID, setLeadId] = useState("");
  const [globalLead, setGlobalLead] = useState(false);
  const [transactionOpen, setTransactionOpen] = useState(false);
  const [LeadData, setLeadData] = useState([]);
  const [openCaptureModal, setOpenCaptureModal] = useState(false);
  const [SameUser, setSameUser] = useState(false);
  const [UnitData, setUnitData] = useState([]);
  const [SelectedLeadDisplayId, setSelectedLeadDisplayId] = useState("");
  const [SelectedLeadName, setSelectedLeadName] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);

  //*Buttons
  const [paymentDetailsButton, setPaymentDetailsButton] = useState(true);
  const [DisabledInterest, setDisabledInterest] = useState(true);
  const [allotedInventoryStatus, setAllottedInventoryStatus] = useState([]);
  const [kycPendingInventoryStatus, setKycPendingInventoryStatus] = useState([]);
  const [HoldInventoryStatus, setHoldInventoryStatus] = useState([]);
  const [InterestQueueTable, setInterestQueueTable] = useState(false);

  const [ProjectPricingDetails, setProjectPricingDetails] = useState([]);
  const [PricingDetails, setPricingDetails] = useState([]);
  const [allotmentPaymentId, setAllotmentPaymentId] = useState("");
  const [fastBooking, setFastBooking] = useState(false);
  const [PayNowButton, setPayNowButton] = useState(false);

  const [LeadValue, setLeadValue] = useState(null);
  const [LeadName, setLeadName] = useState("");
  const [AllLeads, setAllLeads] = useState([]);
  const [AllotmentIdData, setAllotmentIdData] = useState([]);

  const [AllotmentData, setAllotmentData] = useState({
    displayName: "",
  });

  const [helperText, setHelperText] = useState({
    displayName: "",
  });
  // **Project pricing list
  const [listOfProjectPricing, setListOfProjectPricing] = useState([]);
  const [selectedProjectPricingTitle, setSelectedProjectPricingTitle] =
    useState("");
  let WhatsAppMessage = `Hello! Greetings from Vilas Javdekar Developers. You can visit https://vj-customer-app-testing.web.app/ for your preselect payments!`;
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [saleableArea, setSaleableArea] = useState("");
  const [csvUploaded, setCsvUploaded] = useState(false);

  // **Project Payment Plan
  const [listOfProjectPaymentPlan, setListOfProjectPaymentPlan] = useState([]);
  const [selectedProjectPaymentPlanId, setSelectedProjectPaymentPlanId] =
    useState("");
  const [selectedProjectPaymentPlan, setSelectedProjectPaymentPlan] =
    useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const IconOpen = Boolean(anchorEl);

  const id = IconOpen ? 'simple-popover' : undefined;
  const handleIconClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };
  const [
    errorMessageForAlotUnitAlreadyAlloted,
    setErrorMessageForAlotUnitAlreadyAlloted,
  ] = useState("");
  useEffect(() => {
    getInventoryTypeId(unitNo).then((inventoryResp) => {
    getAllPaymentPlans(projectId, wingName,inventoryResp[0].displayUnitType)
      .then((allPaymentPlans) => {

        setListOfProjectPaymentPlan([{title:"none"},...allPaymentPlans.data,]);
      })
      .catch((err) => {
        console.error(err);
      });
    })
  }, []);

  useEffect(() => {
    dispatch(action.activeMenu("directallotment"));
    getUnitData();
    UnitDetails(false);
    getProjectPriceDetails();
  }, []);

  useEffect(() => {
    console.info("LeadID", LeadID);
    console.log("called");
  }, [LeadID]);

  //*snapshot
  useEffect(() => {
    let updateUnitListener = supabase
      .from("Inventory")
      .on("UPDATE", (handleRecordUpdated) => {
        console.log(handleRecordUpdated);
        if (handleRecordUpdated.eventType === "UPDATE") {
          getUnitData();
        }
      })
      .subscribe((status) => {
        console.log("status: ", status);
      });
    return () => {
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
    };
  }, []);

  useEffect(() => {
    defineChipColor();
  }, [ProjectPricingDetails[0]?.inventoryStatusId?.status]);

  useEffect(() => {
    let data = sessionStorage.getItem("fastBookingType");
    console.log("data--------->", data);
    if (data) {
      setFastBooking(true);
    }
  }, []);

  //*global-lead-allotment
  useEffect(() => {
    //*route-From-Global-Lead-Sustenance
    if (getAlotSustananceGlobalRoute() === true) {
      setGlobalLead(true);
      if (getAlotSustananceGlobalUnitAvailable() === true) {
        console.info("Saying Alot unit is Available");
        setPaymentDetailsButton(false);
        let lead = getAlotSustenanceLead();
        console.info("Alot-unit-Lead-Details", lead);
        setLeadId(lead?.leadId);
        let object = {
          LeadName: lead?.leadname,
          LeadDisplayId: lead?.leaddisplayid.replace(
            lead?.leaddisplayid?.substring(8, 12),
            "-" + lead?.leaddisplayid.substring(8, 12)
          ),
          LeadMobileNumber: lead?.leadDetails?.contactNumber,
          LeadEmail: lead?.leadDetails?.leadEmail,
        };
        setLeadData([object]);
        console.log("LeadData===>", lead);
        NextStepsWithLeadId(lead?.leadId);
        setSelectedLeadName(lead?.leadname);
        setSelectedLeadDisplayId(
          lead?.leaddisplayid.replace(
            lead?.leaddisplayid?.substring(8, 12),
            "-" + lead?.leaddisplayid.substring(8, 12)
          )
        );
      } else {
        console.info("Saying Alot unit is Hold");
        let lead = getAlotSustenanceLead();
        setLeadId(lead?.leadId);
        let object = {
          LeadName: lead?.leadname,
          LeadDisplayId: lead?.leaddisplayid.replace(
            lead?.leaddisplayid?.substring(8, 12),
            "-" + lead?.leaddisplayid.substring(8, 12)
          ),
          LeadMobileNumber: lead?.leadDetails?.contactNumber,
          LeadEmail: lead?.leadDetails?.leadEmail,
        };
        setLeadData([object]);
        console.log("LeadData===>", lead);
        NextStepsWithLeadId(lead?.leadId);
        setSelectedLeadName(lead?.leadname);
        setSelectedLeadDisplayId(
          lead?.leaddisplayid.replace(
            lead?.leaddisplayid?.substring(8, 12),
            "-" + lead?.leaddisplayid.substring(8, 12)
          )
        );
      }
    }
  }, []);

  // **GET Sustenance Pricing Plan
  useEffect(() => {
    console.log("price-not-added", priceNotAdded);
  }, []);


  function checkInBasePriceList(object) {
    getUnitByUnitNo(unitNo)
      .then((UnitDetails) => {
        console.log("Unit-Details-checked", UnitDetails.data);
        console.log("object for check", object);
        let inventoryTypeId =
          UnitDetails.data[0].inventoryTypeId.inventoryTypeId;
        let saleableArea = UnitDetails.data[0].saleableArea;
        setSaleableArea(saleableArea);
        if (object) {
          let pricingToShow = object.projectPricingId.basePrices.filter(
            (el) =>
              el.sqft === saleableArea &&
              el.inventoryTypeId === inventoryTypeId
          );
          // **After filtering base Price List
          console.log({ pricingToShow });
          setPricingDetails(pricingToShow);
          console.log(pricingToShow[0]);
        } else {
          setPriceNotAdded(true);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //*Display-of-UnitInterest-Table
  function getUnitData() {
    getActiveLaunchInventory(unitNo)
      .then((active) => {
        let activeTemp = [];
        active.data.forEach((el) => {
          if (el.launchId.eventId !== null) {
            activeTemp.push(el);
          }
        });
        getFutureLaunchInventory(unitNo)
          .then((future) => {
            let futureTemp = [];
            future.data.forEach((elm) => {
              if (elm.launchId.eventId !== null) {
                futureTemp.push(elm);
              }
            });
            //  ! vedashree changes
            if (activeTemp.length > 0 || futureTemp.length > 0) {
              // if (activeTemp.length > 0 && futureTemp.length > 0) {
              setNotForSaleChip(true);
            }
          })
          .catch((err) => {
            console.error("getFutureLaunchInventory", err);
          });
      })
      .catch((err) => {
        console.error("getActiveLaunchInventory", err);
      });
    getUnitByUnitNo(unitNo)
      .then((resp) => {
        // console.info('Unit-Details', resp.data);
        // console.log(
        //   'resp.data[0].inventoryMergeId',
        //   resp.data[0].inventoryMergeId
        // );
        // console.log('resp.data[0].unitId', resp.data[0].unitId);
        setUnitData(resp.data);
        getAllotmentPaymentByUnit(
          resp.data[0].inventoryMergeId?.inventoryMergeId,
          resp.data[0].unitId
        )
          .then((allotmentPaymentRes) => {
            console.log("Allotment-Payment", allotmentPaymentRes);
            if (allotmentPaymentRes.count > 0) {
              allotmentPaymentRes.data[0].allotmentpaymentid =
                allotmentPaymentRes.data[0].allotmentPaymentId;
              setAllotmentIdData(allotmentPaymentRes.data);
              // ! why set unit details to allotment?
              // setAllotmentIdData(resp.data);
              if (resp.data[0]?.leadId?.leadId) {
                setOnHoldData(true);
                const LeadDetails = resp.data.map((el) => ({
                  ...el,
                  Name: el?.leadId.personId?.name,
                  DisplayId: el?.leadId.leadDisplayId.replace(
                    el?.leadId.leadDisplayId.substring(8, 12),
                    "-" + el?.leadId.leadDisplayId.substring(8, 12)
                  ),
                  MobileNumber: el?.leadId.personId.contactNumber,
                  Email: el?.leadId.personId.email,
                }));
                setOnHoldDetails(LeadDetails);
                // console.log('LeadDetails', LeadDetails);
                // console.log('setOnHoldData', OnHoldData);
              }
            }
          })
          .catch((err) => {
            console.error("allotmentPaymentRes", err);
          });
        //*MergeId exists , show details
        if (resp.data[0]?.inventoryMergeId) {
          setMergeIdData(true);
          setMergeID(resp.data[0].inventoryMergeId.inventoryMergeId);
          setUnit1Name(resp.data[0].inventoryMergeId.unit1No);
          setUnit2Name(resp.data[0].inventoryMergeId.unit2No);
          setUnit1(resp.data[0].inventoryMergeId.unit1Id);
          setUnit2(resp.data[0].inventoryMergeId.unit2Id);
        }
        getProjectPricingByUnitId(wingName, projectId)
          .then((inventory) => {
            inventory.data[0]?.basePrices?.forEach((_Item) => {

              if (
                resp.data[0]?.inventoryTypeId?.inventoryTypeId ===
                _Item.inventoryTypeId
              ) {
                if (inventory.data[0].floorRise[0].value) {
                  inventory.data[0].floorRise.forEach((item) => {
                    if (
                      item.from <= resp.data[0].floorNo &&
                      item.to >= resp.data[0].floorNo
                    ) {
                      console.log("item.type", item.type);
                      if (item.type === "Percentage") {
                        if (resp.data[0].saleableArea === _Item.sqft) {
                          const floorRise_per_unit =
                            (parseInt(_Item.BSPTotal) * parseInt(item.value)) /
                            100;
                          setFloorRiseValue(floorRise_per_unit);
                        }
                      } else if (item.type === "Value") {
                        const floorRise_per_unit_by_Value = parseInt(
                          item.value
                        );

                        setFloorRiseValue(floorRise_per_unit_by_Value);
                      }
                    }
                  });
                }

                if (inventory?.data[0]?.plc) {
                  inventory?.data[0]?.plc.forEach((item) => {
                    if (resp?.data[0].view === "") {
                      console.log("item.type", item.type);
                      if (item.type === "Percentage") {
                        if (resp.data[0].saleableArea === _Item.sqft) {
                          const plc_per_unit =
                            (parseInt(_Item.BSPTotal) * parseInt(item.value)) /
                            100;
                          setPlcValue(plc_per_unit);
                        }
                      } else if (item.type === "Value") {
                        const plc_per_unit_by_Value = parseInt(item.value);
                        setPlcValue(plc_per_unit_by_Value);
                      }
                    }
                  });
                }
              }
            });
            setProjectPricingDetails(resp.data);
          })
          .catch((err) => {
            console.error("getProjectPricingByUnitId", err);
          });

        // setUnitData(resp.data);
      })
      .catch((err) => {
        console.error("unit-details-error", err);
      });
  }

  function defineChipColor() {
    let obj = {};
    console.log("---->", ProjectPricingDetails);
    if (ProjectPricingDetails[0]?.inventoryStatusId?.status === "Available") {
      obj.chipColor = "#027A48";
      obj.chipBackgroundColor = "#D1FADF";
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === "On Hold"
    ) {
      obj.chipColor = "#B54708";
      obj.chipBackgroundColor = "#FEF0C7";
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === "Payment Pending"
    ) {
      obj.chipColor = "#B42318";
      obj.chipBackgroundColor = "#FEE4E2";
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === "Reserved"
    ) {
      obj.chipColor = "#6941C6";
      obj.chipBackgroundColor = "#F4EBFF";
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === "Locked"
    ) {
      obj.chipColor = "#344054";
      obj.chipBackgroundColor = "#F2F4F7";
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === "Preselected"
    ) {
      obj.chipColor = "#FF4405";
      obj.chipBackgroundColor = "#FFE6D5";
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === "Kyc Pending"
    ) {
      obj.chipColor = "#0E7090";
      obj.chipBackgroundColor = "#ECFDFF";
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === "Kyc Done"
    ) {
      obj.chipColor = "#0E7090";
      obj.chipBackgroundColor = "#ECFDFF";
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status ===
      "SDR Payment Pending"
    ) {
      obj.chipColor = "#B54708";
      obj.chipBackgroundColor = "#FFFAEB";
    }

    setChipStyle(obj);
  }

  //*Project-details
  function getProjectPriceDetails() {
    getProjectByProjectName(projectId)
      .then((res) => {
        console.log("Project-details", res);
        setProjectData(res.data);
        getUnitByUnitNo(unitNo)
          .then((UnitDetails) => {
            console.log('Inventory-check', UnitDetails.data);
            CheckBookingAmounts(projectId, wingName, UnitDetails.data[0].inventoryTypeId.inventoryTypeId).then((response67) => {
              console.log("Booking-amount-Data", response67)
              setBookingAmountData(response67)
            }).catch((err) => {
              console.error("Booking-amount-err", err)
            })
            getAllPricingPlansByProjectId(projectId, wingName)
              .then((projectPlans) => {
                console.log("***", { projectPlans });
                let filteredData = projectPlans.data.filter(
                  ({ projectPricingId }) => projectPricingId !== null
                );
                console.log("filteredData", filteredData.length);

                console.log(
                  "UnitDetails.data[0]?.BSP",
                  UnitDetails.data[0]?.BSP
                );
                console.log(
                  "res.data[0]?.useCsvPrice",
                  res.data[0]?.useCsvPrice
                );

                if (res.data[0]?.useCsvPrice === false) {
                  setCsvUploaded(false);
                  console.log("***", filteredData);
                  setListOfProjectPricing([...filteredData]);

                  // **To set byDefault in list whose startDateTime and endDateTime is null
                  let findingFirstTitle = filteredData.filter(
                    (el) =>
                      !el.projectPricingId.startDateTime &&
                      !el.projectPricingId.endDateTime
                  );
                  if (filteredData.length === 0) {
                    setPriceNotAdded(true);
                  }
                  console.log({ findingFirstTitle });
                  setSelectedProjectPricingTitle(
                    findingFirstTitle[0]?.projectPricingId.title
                  );
                  // **Check for saleableArea and InventoryTypeId compare in basePrices
                  checkInBasePriceList(findingFirstTitle[0]);
                } else if (res.data[0]?.useCsvPrice === true) {
                  setCsvUploaded(true);
                  console.log("unit-data", UnitDetails.data);
                  // ! if reprice pending; disable 'confirm' button
                  getUnitCancellation(UnitDetails.data[0]?.unitId).then((cancellationResp) => {
                    // console.log('cancellationResp: ', cancellationResp);
                    // if (cancellationResp.data.length === 0) {
                    //   // ! if any error in fetching cancellation requests; show price not added because not sure if repricing done or not
                    //   setPriceNotAdded(true);
                    // }
                    if (UnitDetails.data[0]?.BSP === null || (UnitDetails.data[0]?.BSP === 0 && UnitDetails.data[0]?.GST === 0 && UnitDetails.data[0]?.SDR === 0)) {
                      setPriceNotAdded(true);
                      if (UnitDetails.data[0]?.BSP === 0 && UnitDetails.data[0]?.GST === 0 && UnitDetails.data[0]?.SDR === 0) {
                        setAfterCancelUnitPrice(true)
                      }
                    } else {
                      if (cancellationResp?.data?.[0]?.CancelUnitRequests?.[0]?.status === 'Accepted' && cancellationResp?.data?.[0]?.CancelUnitRequests?.[0]?.unitPriceAlreadyUpdated === false && cancellationResp?.data?.[0]?.CancelUnitRequests?.[0]?.isSkipReprice === false) {
                        setPriceNotAdded(true);
                        setAfterCancelUnitPrice(true);
                      }
                    }
                  }).catch((err) => {
                    console.log('Error in fetching cancellation requests: ', err);
                    // ! if any error in fetching cancellation requests; show price not added because not sure if repricing done or not
                    setPriceNotAdded(true);
                  });
                  setPricingDetails(UnitDetails.data);
                } else if (

                  (UnitDetails.data[0]?.BSP === null && filteredData.length === 0) || res.data[0]?.useCsvPrice === null
                ) {
                  setPriceNotAdded(true);

                }
                let saleableArea = UnitDetails.data[0].saleableArea;
                setSaleableArea(saleableArea);
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log("Project-details", err);
      });

    getAllInventoryStatusFromTable()
      .then((resp) => {
        console.log("Inventory-Status", resp);
        const AllotedStatus = resp.data.filter(
          (f) => f.status === "Payment Pending"
        );
        console.log("Alloted-Status", AllotedStatus[0]?.inventoryStatusId);
        setAllottedInventoryStatus(AllotedStatus[0]?.inventoryStatusId);

        const onHoldStatus = resp.data.filter((f) => f.status === "On Hold");
        console.log("on-Hold-Status", onHoldStatus[0]?.inventoryStatusId);
        setHoldInventoryStatus(onHoldStatus[0]?.inventoryStatusId);
        const kycPending = resp.data.filter(
          (f) => f.status === "Kyc Pending"
        );
        setKycPendingInventoryStatus(kycPending[0]?.inventoryStatusId);
      })
      .catch((err) => {
        console.log("Inventory-Status", err);
      });

    getUnitStatus(unitNo)
      .then((response88) => {
        console.log("getUnitStatus", response88);
        // if (response88[0].InventoryStatus.status === "Payment Pending") {
        if (response88[0].InventoryStatus.status !== "Available") {
          getAllotedLeadFromPaymentsTable(unitNo)
            .then((response22) => {
              console.log("Allotted-Details", response22);
              const UniqAllottedData = uniqBy(response22.data, "leadId.leadId");
              const AllottedLead = UniqAllottedData.map((el) => ({
                ...el,
                LeadName: el?.leadId.personId.name,
                LeadDisplayId: el?.leadId.leadDisplayId.replace(
                  el?.leadId.leadDisplayId.substring(8, 12),
                  "-" + el?.leadId.leadDisplayId.substring(8, 12)
                ),
              }));
              setAllLeads(AllottedLead);
              console.log("AllLeads", AllLeads);
            })
            .catch((err) => {
              console.error("getAllotedLeadFromPaymentsTable", err);
            });
        } else {
          getAllLeadsForSustenance()
            .then((response77) => {
              console.log("leads in sustenance", response77);
              // console.log(
              //   'Available-Details',
              //   response77.data.filter((f) => f.personId !== null)
              // );
              const data = response77.data.filter(
                (f) => f.personId !== null && f.SiteVisits.length > 0
              );
              const UniqData = uniqBy(data, "leadId");
              // console.log('UniqData', UniqData);
              const AvailableData = UniqData.map((lead) => ({
                ...lead,
                LeadName: lead?.personId?.name,
                LeadDisplayId:
                  "VJ" +
                  lead.leadDisplayId.replace(
                    lead.leadDisplayId.substring(8, 12),
                    "-" + lead.leadDisplayId.substring(8, 12)
                  ),
                // siteVisitDone:lead.LeadLogs.filter(({leadStatus})=>leadStatus==='Site Visit Done')
              }));

              console.log("leads list", AvailableData);
              setAllLeads(AvailableData);
            })
            .catch((err) => {
              console.error("getAllLeadNameForToken", err);
            });
        }
      })
      .catch((err) => {
        console.log("getUnitStatus", err);
      });
  }

  //*Searching Data in Leads
  const SearchDataInLeads = debounce((_value) => {
    setLeadName(_value);
    console.log(_value.split(" ").splice(-1));
    if (_value !== "") {
      const SelectedValue = _value.split(" ").splice(-1);
      const FinalValue = SelectedValue[0].slice(2).split("-").join("");
      console.log("FinalValue", FinalValue);
      if (FinalValue !== "") {
        //*getting Lead Details after Search lead Id
        getLeadInfo(FinalValue)
          .then((response33) => {
            console.log(
              "Lead_Data",
              response33.data.filter((f) => f.leadId !== null)
            );
            const FinalLead = response33.data.filter((f) => f.leadId !== null);
            //*getting Lead Details after Search lead Id
            const LeadCard = FinalLead.map((el) => ({
              ...el,
              LeadName: el?.personId.name,
              LeadDisplayId: el?.leadDisplayId.replace(
                el?.leadDisplayId.substring(8, 12),
                "-" + el?.leadDisplayId.substring(8, 12)
              ),
              LeadMobileNumber: el?.personId.contactNumber,
              LeadEmail: el?.personId.email,
              siteVisitDone: el.LeadLogs.filter(
                ({ leadStatus }) => leadStatus === "Site Visit Done"
              ),
            }));
            setLeadData(LeadCard);
            console.log({ LeadCard });
            console.log('Final-Lead', FinalLead);
            if (LeadCard[0]?.siteVisitDone.length === 0) {
              setPaymentDetailsButton(true);
            } else {
              NextStepsWithLeadId(FinalLead[0]?.leadId);
            }
            setLeadId(FinalLead[0]?.leadId);
            console.info("setLeadID", LeadID);
            setSelectedLeadDisplayId(
              FinalLead[0]?.leadDisplayId.replace(
                FinalLead[0]?.leadDisplayId?.substring(8, 12),
                "-" + FinalLead[0]?.leadDisplayId?.substring(8, 12)
              )
            );
            setSelectedLeadName(LeadCard[0]?.LeadName);
          })
          .catch((err) => {
            console.error("Lead_Data", err);
          });
      }
    } else if (_value === "") {
      setPaymentDetailsButton(true);
    }
    //* if user doesn't type anything and clicks on search
    if (AllotmentData.displayName === "") {
      setHelperText((pre) => {
        pre.displayName = "Type leadID or name to search";
        return { ...pre };
      });
    }
  });

  function NextStepsWithLeadId(lead) {
    console.info("leadId", lead);
    //*checking to allow payment button or show interest Button
    getLeadDetailsForSustenance(lead, unitNo)
      .then((response02) => {
        console.info("check if added in interest queue", response02); //*check if added in interest queue
        getLeadDetailsFromInventory(unitNo)
          .then((resp5) => {
            console.info(
              "check lead added in Inventory Table",
              resp5.data[0].leadId
            ); //* check lead added in Inventory Table
            getUnitStatus(unitNo)
              .then((resp8) => {
                console.info("check Status of unit", resp8); //* check Status of unit(hold or available)
                if (
                  lead === resp5.data[0].leadId &&
                  resp8[0].InventoryStatus.status === "Payment Pending"
                ) {
                  console.info("exists in inventory table , alloted unit");
                  setDisabledInterest(true);
                  setPaymentDetailsButton(true);
                  setSameUser(true);
                  setInterestQueueTable(false);
                } else if (lead === resp5.data[0].leadId) {
                  console.info("yes! exists in inventory table, hi again");
                  setDisabledInterest(true);
                  setPaymentDetailsButton(true);
                  setSameUser(true);
                  setInterestQueueTable(false);
                } else {
                  console.info(
                    "No! does-not exists in inventory table , its your first time here"
                  );
                  //*case 1 :unit is available & Interest queue is empty , payment Button: allow
                  if (
                    response02.count === 0 &&
                    resp8[0].InventoryStatus.status === "Available"
                  ) {
                    console.info(
                      "unit is available & Interest queue is empty , payment Button: allow"
                    );
                    setPaymentDetailsButton(false);
                    setSameUser(false);
                    //*case 2: unit is on Hold & lead is not added , show interest button: allow
                  } else if (
                    response02.count === 0 &&
                    resp8[0].InventoryStatus.status === "On Hold"
                  ) {
                    console.info(
                      "unit is on Hold & lead is not added , show interest button: allow"
                    );
                    setDisabledInterest(false);
                    setInterestQueueTable(true);
                    setSameUser(false);
                    //*case 3 :unit is on Hold  & lead exists in interest queue, ask him to wait till unit : available
                  } else if (response02.count > 0) {
                    console.info(
                      "unit is on Hold  & lead exists in interest queue, ask him to wait till unit : available"
                    );
                    setDisabledInterest(true);
                    setPaymentDetailsButton(true);
                    setSameUser(false);
                    setInterestQueueTable(false);
                    // errorTost(`Lead  has been already added!`);
                    //*case 4 : unit is alloted & lead is not the alloted user , he can't do anything
                  } else if (
                    resp8[0].InventoryStatus.status === "Payment Pending" &&
                    response02.count === 0
                  ) {
                    setDisabledInterest(true);
                    setPaymentDetailsButton(true);
                    setSameUser(false);
                    console.info("Unit is Allotted!");
                    //*case 5: unit is available & lead exists in interest queue , payment Button : allow
                  } else if (
                    resp8[0].InventoryStatus.status === "Available" &&
                    response02.count > 0
                  ) {
                    console.info(
                      "unit is available & Interest queue is not empty , payment Button: allow"
                    );
                    setPaymentDetailsButton(false);
                    setSameUser(false);
                    //*case 6 : unit is allotted & lead has done only partial payment , payment Button : allow
                  } else if (
                    resp8[0].InventoryStatus.status === "Payment Pending" &&
                    lead === resp5.data[0].leadId
                  ) {
                    setDisabledInterest(true);
                    setPaymentDetailsButton(true);
                    setSameUser(true);
                  }
                }
              })
              .catch((err) => {
                console.error("check Status of unit", err);
              });
          })
          .catch((err) => {
            console.error("check lead added in Inventory Table", err);
          });
      })
      .catch((err) => {
        console.error("check if added in interest queue", err);
      });
  }

  function PutTheUnitOnHold(value) {
    console.log("Value-clicked", value);
    console.info("LeadID", LeadID);
    presentLoader();
    getUnitStatus(unitNo)
      .then((res) => {
        // ??res[0] is unitData
        console.info("unit-Data", res); //*check Unit Status
        console.info("Unit-Status", res[0].InventoryStatus.status); //*check unit status
        //*steps: put the unit to on hold
        if (BookingAmountData.length > 0) {
          if (res[0].InventoryStatus.status === "Available") {
            // !!After Cancellation Alot unit
            let paidAlready = 0;
            let paidAmtObj = {
              ocr: null,
              gst: null,
              sdr: null,
            };
            if (getAlotSustenanceLead()?.oldAllotmentData) {
              paidAlready = getAlotSustenanceLead()?.oldAllotmentData?.updatedunitprice?.cancellationCharges ? (getAlotSustenanceLead()?.oldAllotmentData?.paidamount - getAlotSustenanceLead()?.oldAllotmentData?.updatedunitprice?.cancellationCharges) : getAlotSustenanceLead()?.oldAllotmentData?.paidamount;
              // ??variable "newAmount" used for bucketing
              let newAmount =
                getAlotSustenanceLead()?.oldAllotmentData?.updatedunitprice
                  ?.cancellationCharges ? getAlotSustenanceLead()?.oldAllotmentData?.paidamount - getAlotSustenanceLead()?.oldAllotmentData?.updatedunitprice
                    ?.cancellationCharges : getAlotSustenanceLead()?.oldAllotmentData?.paidamount;
              // ??newAmount is less than BookingAmountData
              if (newAmount <= BookingAmountData[0]?.TOTAL) {
                if (newAmount <= BookingAmountData[0]?.OCR) {
                  paidAmtObj.ocr = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0]?.OCR) {
                  paidAmtObj.ocr = BookingAmountData[0]?.OCR;
                  newAmount = newAmount - BookingAmountData[0]?.OCR;
                }
                if (newAmount <= BookingAmountData[0]?.GST) {
                  paidAmtObj.gst = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0]?.GST) {
                  paidAmtObj.gst = BookingAmountData[0]?.GST;
                  newAmount = newAmount - BookingAmountData[0]?.GST;
                }
                if (newAmount <= BookingAmountData[0]?.SDR) {
                  paidAmtObj.sdr = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0]?.SDR) {
                  paidAmtObj.sdr = BookingAmountData[0]?.SDR;
                  newAmount = newAmount - BookingAmountData[0]?.SDR;
                }
              } else {
                // !!Flow for if BookingAmountData[0]?.TOTAL >newAmount
                // ??Same flow like before
                if (newAmount <= BookingAmountData[0]?.OCR) {
                  paidAmtObj.ocr = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0]?.OCR) {
                  paidAmtObj.ocr = BookingAmountData[0]?.OCR;
                  newAmount = newAmount - BookingAmountData[0]?.OCR;
                }
                if (newAmount <= BookingAmountData[0]?.GST) {
                  paidAmtObj.gst = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0]?.GST) {
                  paidAmtObj.gst = BookingAmountData[0]?.GST;
                  newAmount = newAmount - BookingAmountData[0]?.GST;
                }
                if (newAmount <= BookingAmountData[0]?.SDR) {
                  paidAmtObj.sdr = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0]?.SDR) {
                  paidAmtObj.sdr = BookingAmountData[0]?.SDR;
                  newAmount = newAmount - BookingAmountData[0]?.SDR;
                }
                // ??After bucket is filled now bucket filling from comparing from Unit Cost
                if (newAmount <= (PricingDetails[0]?.BSP - BookingAmountData[0]?.OCR)) {
                  paidAmtObj.ocr = paidAmtObj.ocr + newAmount;
                  newAmount = 0;
                } else if (newAmount > (PricingDetails[0]?.BSP - BookingAmountData[0]?.OCR)) {
                  paidAmtObj.ocr = paidAmtObj.ocr + (PricingDetails[0]?.BSP - BookingAmountData[0]?.OCR);
                  newAmount = newAmount - (PricingDetails[0]?.BSP - BookingAmountData[0]?.OCR);
                }
                if (newAmount <= (PricingDetails[0]?.SDR - BookingAmountData[0]?.SDR)) {
                  paidAmtObj.sdr = paidAmtObj.sdr + newAmount;
                  newAmount = 0;
                } else if (newAmount > (PricingDetails[0]?.SDR - BookingAmountData[0]?.SDR)) {
                  paidAmtObj.sdr = paidAmtObj.sdr + (PricingDetails[0]?.SDR - BookingAmountData[0]?.SDR);
                  newAmount = newAmount - (PricingDetails[0]?.SDR - BookingAmountData[0]?.SDR);
                }
                if (newAmount <= (PricingDetails[0]?.GST - BookingAmountData[0]?.GST)) {
                  paidAmtObj.gst = paidAmtObj.gst + newAmount;
                  newAmount = 0;
                } else if (newAmount > (PricingDetails[0]?.GST - BookingAmountData[0]?.GST)) {
                  paidAmtObj.gst = paidAmtObj.gst + (PricingDetails[0]?.GST - BookingAmountData[0]?.GST);
                  newAmount = newAmount - (PricingDetails[0]?.GST - BookingAmountData[0]?.GST);
                }
              }

              console.log({ paidAmtObj });
            }

            //*step 1: insert into Allotment table
            let AllotmentDetails = {
              leadId: LeadID,
              userId: loggedInUser?.userId,
              unitId: mergeIdData === true ? null : unitNo,
              // SDR: 0,
              // OCR: 0,
              // GST: parseFloat(PricingDetails[0]?.GST),
              // totalCost: parseFloat(PricingDetails[0]?.Total),
              unitCost: {
                bsp:
                  csvUploaded === false
                    ? mergeIdData
                      ? parseFloat(PricingDetails[0]?.BSPTotal) +
                      parseFloat(PricingDetails[0]?.BSPTotal)
                      : parseFloat(PricingDetails[0]?.BSPTotal)
                    : mergeIdData
                      ? parseFloat(PricingDetails[0]?.BSP) +
                      parseFloat(PricingDetails[0]?.BSP)
                      : parseFloat(PricingDetails[0]?.BSP),
                sdr: mergeIdData
                  ? parseFloat(PricingDetails[0]?.SDR) +
                  parseFloat(PricingDetails[0]?.SDR)
                  : parseFloat(PricingDetails[0]?.SDR),
                gst: mergeIdData
                  ? parseFloat(PricingDetails[0]?.GST) +
                  parseFloat(PricingDetails[0]?.GST)
                  : parseFloat(PricingDetails[0]?.GST),
                total:
                  csvUploaded === false
                    ? mergeIdData
                      ? parseFloat(
                        PricingDetails[0]?.Total
                        // +
                        //   PricingDetails[0]?.Total +
                        //   FloorRiseValue
                      )
                      : parseFloat(PricingDetails[0]?.Total)
                    // : parseFloat(PricingDetails[0]?.Total + FloorRiseValue)
                    : mergeIdData
                      ? parseFloat(
                        PricingDetails[0]?.totalCost
                        // +
                        //   PricingDetails[0]?.totalCost +
                        //   FloorRiseValue
                      )
                      : parseFloat(PricingDetails[0]?.totalCost),
                // : parseFloat(PricingDetails[0]?.totalCost + FloorRiseValue),
              },
              bookingAmt: {
                ocr: BookingAmountData[0]?.OCR,
                sdr: BookingAmountData[0]?.SDR,
                gst: BookingAmountData[0]?.GST,
                total: BookingAmountData[0]?.TOTAL,
              },
              paymentPlan: selectedProjectPaymentPlan === null ? null : selectedProjectPaymentPlan.title === "none" ? null : {
                ...selectedProjectPaymentPlan,
              },
              paymentPlanId : selectedProjectPaymentPlan === null ? null : selectedProjectPaymentPlan.title === "none" ? null : selectedProjectPaymentPlan ?  selectedProjectPaymentPlan?.paymentPlanId :  null,
              pricingType: "sustenance",
              paidAmount: getAlotSustenanceLead()?.oldAllotmentData ? paidAlready : 0,
              inventoryMergedId: mergeIdData === true ? mergeID : null,
              status: getAlotSustenanceLead()?.oldAllotmentData
                ? paidAlready >= BookingAmountData[0]?.TOTAL
                  ? "Payment Complete"
                  : "Partial Payment Done"
                : value === "Hold & Continue"
                  ? "Payment Pending"
                  : "On Hold", // ! vedashree changes here,
              // ??no need of paidAmt now as at the end we are calling bucketing api
              // getAlotSustenanceLead()?.oldAllotmentData ? paidAmtObj : 
              paidAmt: null,
            };
            let unitStatusArray = [];
            if (mergeIdData === true) {
              unitStatusArray.push({
                StatusId:
                  getAlotSustenanceLead()?.oldAllotmentData
                    ? paidAlready >= BookingAmountData[0]?.TOTAL
                      ? kycPendingInventoryStatus
                      : allotedInventoryStatus
                    :
                    value === "Hold & Continue"
                      ? allotedInventoryStatus
                      : HoldInventoryStatus,
                unitId: Unit1,
                leadId: LeadID,
                UnitHoldTime: new Date().getTime(),
              });
              unitStatusArray.push({
                StatusId:
                  getAlotSustenanceLead()?.oldAllotmentData
                    ? paidAlready >= BookingAmountData[0]?.TOTAL
                      ? kycPendingInventoryStatus
                      : allotedInventoryStatus
                    :
                    value === "Hold & Continue"
                      ? allotedInventoryStatus
                      : HoldInventoryStatus,
                unitId: Unit2,
                leadId: LeadID,
                UnitHoldTime: new Date().getTime(),
              });
            } else {
              unitStatusArray.push({
                StatusId:
                  getAlotSustenanceLead()?.oldAllotmentData
                    ? paidAlready >= BookingAmountData[0]?.TOTAL
                      ? kycPendingInventoryStatus
                      : allotedInventoryStatus
                    :
                    value === "Hold & Continue"
                      ? allotedInventoryStatus
                      : HoldInventoryStatus,
                unitId: unitNo,
                leadId: LeadID,
                UnitHoldTime: new Date().getTime(),
              });
            }
            const leadStatus =
              value === "Hold & Continue"
                ? "Allotment Payment Pending"
                : "Unit On Hold";
            console.log({ AllotmentDetails });
            // InsertIntoAllotmentTable(AllotmentDetails)
            //   .then((response44) => {
            //     console.log("Added-into-Allotment-table", response44);
            //     //*step 1:add to leadId to inventory Table and put status onHold
            //     if (mergeIdData === true) {
            //       UpdateUnitStatus(
            //         // ! vedashree changes here
            //         value === "Hold & Continue"
            //           ? allotedInventoryStatus
            //           : HoldInventoryStatus,
            //         // HoldInventoryStatus,
            //         Unit1,
            //         LeadID,
            //         new Date().getTime()
            //       )
            //         .then((response34) => {
            //           console.log("Status-updated", response34);
            //           let InventoryLogObj = {
            //             userId: loggedInUser?.userId,
            //             leadId: LeadID,
            //             // ! vedashree changes here
            //             status:
            //               value === "Hold & Continue"
            //                 ? "Payment Pending"
            //                 : "On Hold",
            //             unitId: Unit1,
            //           };
            //           insertInventoryLogs(InventoryLogObj)
            //             .then((insertInventoryLogsRes) => {
            //               console.log({ insertInventoryLogsRes });
            //             })
            //             .catch((err) => {
            //               console.log(
            //                 "err while inserting into inventory log",
            //                 err
            //               );
            //             });
            //         })
            //         .catch((err) => {
            //           console.log("Status-updated", err);
            //         });
            //       UpdateUnitStatus(
            //         // ! vedashree changes here
            //         value === "Hold & Continue"
            //           ? allotedInventoryStatus
            //           : HoldInventoryStatus,
            //         // HoldInventoryStatus,
            //         Unit2,
            //         LeadID,
            //         new Date().getTime()
            //       )
            //         .then((response34) => {
            //           console.log("Status-updated", response34);
            //           let InventoryLogObj = {
            //             userId: loggedInUser?.userId,
            //             leadId: LeadID,
            //             // ! vedashree changes here
            //             status:
            //               value === "Hold & Continue"
            //                 ? "Payment Pending"
            //                 : "On Hold",
            //             unitId: Unit2,
            //           };
            //           insertInventoryLogs(InventoryLogObj)
            //             .then((insertInventoryLogsRes) => {
            //               console.log({ insertInventoryLogsRes });
            //             })
            //             .catch((err) => {
            //               console.log(
            //                 "err while inserting into inventory log",
            //                 err
            //               );
            //             });
            //         })
            //         .catch((err) => {
            //           console.log("Status-updated", err);
            //         });
            //     } else {
            //       UpdateUnitStatus(
            //         // ! vedashree changes here
            //         value === "Hold & Continue"
            //           ? allotedInventoryStatus
            //           : HoldInventoryStatus,
            //         // HoldInventoryStatus,
            //         unitNo,
            //         LeadID,
            //         new Date().getTime()
            //       )
            //         .then((response34) => {
            //           console.log("Status-updated", response34);
            //           let InventoryLogObj = {
            //             userId: loggedInUser?.userId,
            //             leadId: LeadID,
            //             // ! vedashree changes here
            //             status:
            //               value === "Hold & Continue"
            //                 ? "Payment Pending"
            //                 : "On Hold",
            //             unitId: unitNo,
            //           };
            //           insertInventoryLogs(InventoryLogObj)
            //             .then((insertInventoryLogsRes) => {
            //               console.log({ insertInventoryLogsRes });
            //             })
            //             .catch((err) => {
            //               console.log(
            //                 "err while inserting into inventory log",
            //                 err
            //               );
            //             });
            //         })
            //         .catch((err) => {
            //           console.log("Status-updated", err);
            //         });
            //     }
            //     updateLeadStatusForAllotment(
            //       LeadID,
            //       // ! vedashree changes here
            //       value === "Hold & Continue"
            //         ? "Allotment Payment Pending"
            //         : "Unit On Hold",
            //       response44.data[0].allotmentPaymentId,
            //       null
            //     )
            //       .then((response11) => {
            //         console.info("lead-Status-Updated", response11);
            //         if (value === "Hold & Continue") {
            //           handleClose();
            //           setOpenPaymentModal(true);
            //           if (mergeIdData === true) {
            //             let obj = {
            //               leadId: LeadID,
            //               leadStatus:
            //                 value === "Hold & Continue"
            //                   ? "Allotment Payment Pending"
            //                   : "Unit On Hold",
            //               // leadStatus: 'Unit On Hold',
            //               message: ` Unit ${UnitData[0]?.wingId?.wingName} - ${Unit1Name},${Unit2Name} InventoryType-${UnitData[0].inventoryTypeId.type} Put on Hold by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
            //             };
            //             addLeadLogs(obj)
            //               .then((leadLog) => {
            //                 console.log(leadLog);
            //               })
            //               .catch((err) => {
            //                 console.error("leadlog", err);
            //               });
            //             successTost(
            //               `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${Unit1Name},${Unit2Name} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
            //             );
            //             dismissLoader();
            //           } else {
            //             let obj = {
            //               leadId: LeadID,
            //               leadStatus:
            //                 value === "Hold & Continue"
            //                   ? "Allotment Payment Pending"
            //                   : "Unit On Hold",
            //               message: `Unit ${UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo} InventoryType-${UnitData[0].inventoryTypeId.type} Put on Hold by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
            //             };
            //             addLeadLogs(obj)
            //               .then((leadLog) => {
            //                 console.log(leadLog);
            //               })
            //               .catch((err) => {
            //                 console.error("leadlog", err);
            //               });
            //             successTost(
            //               `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
            //             );
            //             dismissLoader();
            //           }

            //           response44.data[0].allotmentpaymentid =
            //             response44.data[0].allotmentPaymentId;
            //           setAllotmentIdData(response44.data);
            //         } else {
            //           handleClose();
            //           if (mergeIdData) {
            //             let obj = {
            //               leadId: LeadID,
            //               leadStatus: "Unit On Hold",
            //               message: ` Unit ${UnitData[0]?.wingId?.wingName} - ${Unit1Name},${Unit2Name} InventoryType-${UnitData[0].inventoryTypeId.type} Put on Hold by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
            //             };
            //             addLeadLogs(obj)
            //               .then((leadLog) => {
            //                 console.log(leadLog);
            //               })
            //               .catch((err) => {
            //                 console.error("leadlog", err);
            //               });
            //             successTost(
            //               `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
            //             );
            //             getUnitData();
            //             dismissLoader();
            //           } else {
            //             let obj = {
            //               leadId: LeadID,
            //               leadStatus: "Unit On Hold",
            //               message: `Unit ${UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo} InventoryType-${UnitData[0]?.inventoryTypeId?.type} Put on Hold by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
            //             };
            //             addLeadLogs(obj)
            //               .then((leadLog) => {
            //                 console.log(leadLog);
            //               })
            //               .catch((err) => {
            //                 console.error("leadlog", err);
            //               });
            //             successTost(
            //               `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
            //             );
            //             getUnitData();
            //             dismissLoader();
            //           }
            //         }
            //       })
            //       .catch((err) => {
            //         console.error("lead-Status-Updated", err);
            //         dismissLoader();
            //       });
            //   })
            //   .catch((err) => {
            //     console.error("Update-Status-err", err);
            //     dismissLoader();
            //   });

            allotUnit(
              AllotmentDetails,
              unitStatusArray,
              null,
              null,
              UnitData,
              loggedInUser,
              getAlotSustenanceLead()?.oldAllotmentData
                ? paidAlready >= BookingAmountData[0]?.TOTAL
                  ? "Allotment Payment Complete"
                  : "Allotment Partial Payment Done"
                : leadStatus
            )
              .then((allotUnitResponse) => {
                console.log("allotUnitResponse => ", allotUnitResponse);
                if (allotUnitResponse?.data?.success) {

                  if (mergeIdData === true) {
                    // successTost(
                    //   `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${Unit1Name},${Unit2Name} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
                    // );
                    successTost(
                      `Hold Unit ${UnitData[0]?.wingId?.displayName ? UnitData[0]?.wingId?.displayName : UnitData[0]?.wingId?.wingName} - ${Unit1Name},${Unit2Name} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
                    );
                  } else {
                    // successTost(
                    //   `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
                    // );
                    successTost(
                      `Hold Unit ${UnitData[0]?.wingId?.displayName ? UnitData[0]?.wingId?.displayName : UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
                    );
                  }
                  handleClose();
                  dismissLoader();
                  if (value === "Hold & Continue") {
                    // ?? alot unit after cancellation unit update alotmentTransactions table with new id
                    if (getAlotSustenanceLead()?.oldAllotmentData) {
                      let allotmentObj = {
                        allotmentPaymentId:
                          allotUnitResponse.data.allotmentPaymentId,
                        unitId: mergeIdData === true ? null : unitNo
                      };
                      updateAllotmentTransactionsForTrnsUpdate(
                        getAlotSustenanceLead()?.oldAllotmentData
                          ?.allotmentpaymentid,
                        allotmentObj
                      )
                        .then((alotmenttrnsUpdate) => {
                          console.log({ alotmenttrnsUpdate });
                          let allotmentObject = {
                            paymentTransferred: true,
                          }
                          updateAllotmentPayment(allotmentObject, getAlotSustenanceLead()?.oldAllotmentData?.allotmentpaymentid)
                            .then((updateAllotmentPaymentRes) => {
                              console.log({ updateAllotmentPaymentRes });
                              let bucketingObj = {
                                allotmentPaymentId: allotUnitResponse.data.allotmentPaymentId
                              }
                              bucketingForChangeUnit(bucketingObj).then((bucketingResp) => {
                                console.log({ bucketingResp });
                                if (bucketingResp.data.success) {
                                  // ??success
                                  getAllotmentPayment(
                                    allotUnitResponse.data.allotmentPaymentId
                                  )
                                    .then((apResp) => {
                                      console.log({ apResp })
                                      dismissLoader();
                                      handleClose();
                                      if (apResp.data.length > 0) {
                                        apResp.data[0].allotmentpaymentid = apResp.data[0].allotmentPaymentId;
                                        // AllotmentIdData = apResp.data;
                                        setAllotmentIdData(apResp.data);
                                        if (getAlotSustenanceLead()?.oldAllotmentData && paidAlready >= BookingAmountData[0]?.TOTAL) {
                                          dismissLoader();
                                        } else {
                                          setOpenPaymentModal(true);
                                          setPayNowButton(true);
                                        }
                                        dismissLoader();
                                      } else {
                                        errorTost(
                                          "Something went wrong. Go To All Allotments for payments!"
                                        );
                                        dismissLoader();
                                      }
                                      dismissLoader();
                                    })
                                    .catch((err) => {
                                      console.error("getAllotmentPayment", err);
                                    });
                                } else {
                                  dismissLoader();
                                  errorTost(bucketingResp.data.message);
                                }
                              }).catch((err) => {
                                console.log(err);
                              });
                            }).catch((err) => {
                              console.log(err);
                            });
                          let logObj = {
                            oldAllotmentId: getAlotSustenanceLead()?.oldAllotmentData?.allotmentpaymentid,
                            newAllotmentId: allotUnitResponse.data.allotmentPaymentId,
                            userId: loggedInUser?.userId
                          };
                          insertTransactionLogs(logObj)
                            .then((resplog) => {
                              console.log({ resplog });
                            })
                            .catch((err) => {
                              console.log("err while inserting logs");
                            });
                          let message = `<h4>Hi ${getAlotSustenanceLead()?.oldAllotmentData?.leadname},</h4></br>
                          <p>Adjust Allotment Done!</br>
                          Cancelled Unit:${getAlotSustenanceLead()?.oldAllotmentData.projectname},${getAlotSustenanceLead()?.oldAllotmentData.displaywingname ? getAlotSustenanceLead()?.oldAllotmentData.displaywingname : getAlotSustenanceLead()?.oldAllotmentData.wingname},${getAlotSustenanceLead()?.oldAllotmentData.unitno}</br>
                          Balance amount: ${getAlotSustenanceLead()?.oldAllotmentData.paidamount} has been adjusted in ${ProjectData[0]?.projectName},${UnitData[0]?.wingId?.displayName ? UnitData[0]?.wingId?.displayName : UnitData[0]?.wingId?.wingName}-${UnitData[0]?.unitNo}</br>
                          Done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})</b></p></br>
                         `;
                          let emailbody = {
                            to: [getAlotSustenanceLead()?.oldAllotmentData?.leademail],
                            subject: "Adjust Allotment Done through Sustenance",
                            message: message,
                          };
                          // let messageBody = {
                          //   number: "+" + data.leadcontactnumber,
                          //   message: `Cancelled Unit:${oldAllotmentData.projectname},${oldAllotmentData.wingname},${oldAllotmentData.unitno}, balance amount: ${oldAllotmentData.paidamount} has been adjusted in ${availableData?.projectName}|${availableData?.wingName} |${availableData?.unitNo} done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
                          //   is_international_number:
                          //     data.leadcontactnumber.toString().substring(0, 2) !== "91"
                          //       ? true
                          //       : false,
                          // };
                          // const sms = await sendMessage(messageBody)
                          //   .then((resp) => {
                          //     if (resp.data.success) {
                          //       return true;
                          //     } else {
                          //       if (resp?.data?.error) {
                          //         return false;
                          //       }
                          //     }
                          //   })
                          //   .catch((err) => {
                          //     return false;
                          //   });
                          const emailRes = sendMailTo(emailbody)
                            .then((resp) => {
                              console.log(resp);
                              if (resp.data.status === "err") {
                                return false;
                              } else {
                                return true;
                              }
                            })
                            .catch((err) => {
                              console.log(err);
                              return false;
                            });

                        })
                        .catch((error) => {
                          console(
                            "error while updating transactions alottmentpayment id"
                          );
                        });
                    } else {
                      getAllotmentPayment(
                        allotUnitResponse.data.allotmentPaymentId
                      )
                        .then((apResp) => {
                          console.log({ apResp })
                          dismissLoader();
                          handleClose();
                          if (apResp.data.length > 0) {
                            apResp.data[0].allotmentpaymentid = apResp.data[0].allotmentPaymentId;
                            // AllotmentIdData = apResp.data;
                            setAllotmentIdData(apResp.data);
                            if (getAlotSustenanceLead()?.oldAllotmentData && paidAlready >= BookingAmountData[0]?.TOTAL) {
                              dismissLoader();
                            } else {
                              setOpenPaymentModal(true);
                              setPayNowButton(true);
                            }
                            dismissLoader();
                          } else {
                            errorTost(
                              "Something went wrong. Go To All Allotments for payments!"
                            );
                            dismissLoader();
                          }
                          dismissLoader();
                        })
                        .catch((err) => {
                          console.error("getAllotmentPayment", err);
                        });
                    }


                  } else {
                    dismissLoader();
                    getUnitData();
                  }
                } else {
                  if (allotUnitResponse?.data?.error) {
                    errorTost(allotUnitResponse?.data?.error);
                  } else {
                    errorTost("Something went wrong! Try again");
                  }
                  handleClose();
                  dismissLoader();
                }
              })
              .catch((allotUnitError) => {
                dismissLoader();
                console.error("allotUnitError => ", allotUnitError);
                handleClose();
                if (
                  allotUnitError?.response.data.error &&
                  typeof allotUnitError?.response.data.error === "string"
                ) {
                  errorTost(allotUnitError?.response?.data?.error);
                } else {
                  errorTost("Something went wrong! Try again");
                }
              });

          } else {
            handleClose();
            dismissLoader();
            errorTost("Unit is not available.");
          }
        } else {
          handleClose();
          dismissLoader();
          errorTost("Booking amount not added, contact your admin.");
        }
      })
      .catch((err) => {
        console.error("getUnitStatus", err);
        dismissLoader();
      });
  }

  function PaymentDetails() {
    if (SameUser === true) {
      console.info("hi , again");
      console.log("AllotmentIdData", AllotmentIdData);
    } else {
      console.info("oh, first time");
      //*case 1 :payment button : allow
      getLeadDetailsFromInventory(unitNo)
        .then((response88) => {
          console.info("Inventory-Table-Data-->", response88.data[0].leadId); //* check lead is added in inventory Table
          getUnitStatus(unitNo)
            .then((response6) => {
              console.info("Unit-Data", response6);
              //*case 1: not added to inventory Table & unit is available , put unit Status : on Hold
              if (
                response88.data[0].leadId === null &&
                response6[0].InventoryStatus.status === "Available"
              ) {
                handleOpen();
              } else if (
                //* case 2: not added to inventory Table & unit is on hold , ask him to wait unit : available
                response88.data[0].leadId === null &&
                response6[0].InventoryStatus.status === "On Hold"
              ) {
                infoTost(
                  "This Unit is on hold , Please wait until it's available"
                );
                setDisabledInterest(false);
                setInterestQueueTable(true);
              }
            })
            .catch((err) => {
              console.error("Unit-Data", err);
            });
        })
        .catch((err) => {
          console.error("Inventory-Table-Data", err);
        });
    }
  }

  function OnSubmit(data) {
    PutTheUnitOnHold(data);
    setPaymentDetailsButton(true);
  }

  //*Add-Lead-UnitInterest-Table
  function ShowInterestByLeadName() {
    console.info("leadid", LeadID);
    console.info("unitId", unitNo);

    let InterestData = {
      leadId: LeadID,
      unitId: unitNo,
    };

    AddUnitInterest(InterestData)
      .then((response) => {
        console.info("Update-Interest-Data", response);
        successTost(`${LeadData[0].LeadName} has shown interest successfully`);
        UnitDetails(false);
        setDisabledInterest(true);
        setPaymentDetailsButton(true);
      })
      .catch((err) => {
        console.error("Update-Interest-Data-LeadName", err);
      });
  }

  function UnitDetails(merge) {
    getAllUnitInterests(
      unitNo,
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1
    )
      .then((res) => {
        console.info("All-Unit-Interests", res);
        const UnitData = res.data.map((el, index) => ({
          ...el,
          id: el.unitInterestId,
          index: index,
        }));

        if (merge) {
          setUnitInterestData((pre) => [...pre, ...UnitData]);
        } else {
          setUnitInterestData([...UnitData]);
        }
      })
      .catch((err) => {
        console.error("Unit-Interests-table-err", err);
      });
  }

  const ProjectColumns = [
    {
      field: "id",
      headerName: "",
      width: 20,
      renderCell: (params) => {
        return <Box>{params.row.index + 1}</Box>;
      },
    },
    {
      field: "TimeStamp",
      headerName: "Time Stamp",
      width: 190,
      renderCell: (params) => {
        return (
          <Box>
            {new Date(params.row.created_at).toDateString()},{" "}
            {new Date(params.row.created_at).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </Box>
        );
      },
    },
    {
      field: "LeadName",
      headerName: "Lead Name",
      width: 200,
      renderCell: (params) => {
        return (
          <Box>
            {params?.row?.leadId?.personId?.name
              ? params?.row?.leadId?.personId?.name
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "SalesRepresentative",
      headerName: "Sales Representative",
      width: 190,
      renderCell: (params) => {
        return (
          <Box>
            {params?.row?.leadId?.userId?.name
              ? params?.row?.leadId?.userId?.name
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 70,
      renderCell: (params) => {
        return (
          <ThreeDotsMenu
            list={["remove"]}
            selectedValue={(_value) => {
              selectedOption(params.row);
            }}
          />
        );
      },
    },
  ];



  //*Delete-Lead-from-Unit-Interest-Table
  function selectedOption(data) {
    console.log(data.leadId.personId.name);
    if (data !== "") {
      console.info("Unit-interest-Id", data?.unitInterestId);
      RemoveLeadFromInterestQueue(data?.unitInterestId)
        .then((res) => {
          console.info("SuccessFully Removed", res);
          UnitDetails(false);
          successTost(
            `${data?.leadId?.personId?.name} has been successFully removed!`
          );
        })
        .catch((err) => {
          errorTost("Something went wrong! try again");
          console.error("unit-remove-err", err);
        });
    }
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }

  return (
    <>
      {!openPaymentModal && (
        <>
          <Box className={cssClasses.Container}>
            <>
              <Box
                margin={"2rem"}
                className={cssClasses.SearchDiv1}
                style={{ justifyContent: "space-between" }}
              >
                <Box width={"calc(40% - 1rem)"}>
                  <Box className={cssClasses.headerTitle1}>
                    {ProjectData[0]?.projectName}
                  </Box>
                  <Box className={cssClasses.subTitle} mt={1}>
                    {ProjectData[0]?.addressLine1},{" "}
                    {ProjectData[0]?.addressLine2}{" "}
                    {ProjectData[0]?.addressLine3}
                  </Box>
                </Box>
                <Box className={cssClasses.unitDetails}>
                  {mergeIdData ? (
                    <Box className={cssClasses.headerTitle1} ml={1}>
                      {/* {UnitData[0]?.wingId?.wingName}- */}
                      {UnitData[0]?.wingId?.displayName ? UnitData[0]?.wingId?.displayName : UnitData[0]?.wingId?.wingName}-
                      {UnitData[0]?.inventoryMergeId?.unit1No <
                        UnitData[0]?.inventoryMergeId?.unit2No
                        ? `${UnitData[0]?.inventoryMergeId?.unit1No} , ${UnitData[0]?.inventoryMergeId?.unit2No}`
                        : `${UnitData[0]?.inventoryMergeId?.unit2No} , ${UnitData[0]?.inventoryMergeId?.unit1No}`}
                      <Box className={cssClasses.subTitle} mt={1}>
                        {ProjectData[0]?.displayInventoryType?.includes(
                          "Inventory Type"
                        )
                          ? UnitData[0]?.inventoryTypeId?.type
                          : ""}
                        {ProjectData[0]?.displayInventoryType?.includes(
                          "Display Unit Type"
                        ) && "(" + UnitData[0]?.displayUnitType + ")"}
                      </Box>
                    </Box>
                  ) : (
                    <Box className={cssClasses.headerTitle1} ml={1}>
                      {/* {UnitData[0]?.wingId?.wingName}-{UnitData[0]?.unitNo} */}
                      {UnitData[0]?.wingId?.displayName ? UnitData[0]?.wingId?.displayName : UnitData[0]?.wingId?.wingName}-{UnitData[0]?.unitNo}
                      <Box className={cssClasses.subTitle} mt={1}>
                        {ProjectData[0]?.displayInventoryType?.includes(
                          "Inventory Type"
                        )
                          ? UnitData[0]?.inventoryTypeId?.type
                          : ""}
                        {ProjectData[0]?.displayInventoryType?.includes(
                          "Display Unit Type"
                        ) &&
                          UnitData[0]?.displayUnitType !== null &&
                          "(" + UnitData[0]?.displayUnitType + ")"}
                      </Box>
                    </Box>
                  )}
                  <Box className={cssClasses.statusWrap}>
                    {/* <Box className={cssClasses.subTitle}> */}
                    {/* {NotForSaleChip === false ?  */}
                    <LeadStatusChip
                      style={{
                        color: ChipStyle?.chipColor,
                        backgroundColor: ChipStyle?.chipBackgroundColor,
                      }}
                      label={
                        ProjectPricingDetails[0]?.inventoryStatusId?.status
                      }
                      icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                    />
                    {NotForSaleChip && (
                      <LeadStatusChip
                        style={{
                          color: "#B42318",
                          backgroundColor: "#FEE4E2",
                        }}
                        label={"Not for Sale"}
                        icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </>

            <>
              <Box height={"100%"} overflow={"auto"}>
                {/* Adding Dropdown for Pricing */}

                {/* <Divider /> */}

                <Box className={cssClasses.wrapperDropDownAndPrices}>
                  {priceNotAdded === false ? (
                    <>
                      {!ProjectData[0]?.csvUploaded && (
                        <Box className={cssClasses.wrapperDropDown}>
                          <div className={cssClasses.dropDown}>
                            <DropDown
                              list={listOfProjectPricing.map((element, id) => {
                                return {
                                  label: element.projectPricingId.title,
                                  value: element.projectPricingId.title,
                                };
                              })}
                              selectedValue={selectedProjectPricingTitle}
                              onChangeSelect={(value) => {
                                setSelectedProjectPricingTitle(value);
                                let selectedProjectPricing =
                                  listOfProjectPricing.filter(
                                    (el) =>
                                      value === el?.projectPricingId?.title
                                  );
                                checkInBasePriceList(selectedProjectPricing[0]);
                              }}
                              placeHolder={""}
                              style={{
                                background: "#F2F4F7",
                                color: "rgb(102, 112, 133)",
                              }}
                            />
                          </div>
                        </Box>
                      )}

                      <Box>
                        <Box className={cssClasses.subTitle}>Saleable Area of Unit:</Box>
                        <Box className={cssClasses.headerTitle1} mt={1}>
                          {saleableArea
                            ? numberWithCommas(saleableArea)
                            : "-"}{" "}
                          Sq.Ft.
                        </Box>
                      </Box>

                      <Box>
                        <Box className={cssClasses.subTitle}>Agreement Value:</Box>
                        {mergeIdData ? (
                          <Box className={cssClasses.headerTitle1} mt={1}>
                            ₹{" "}
                            {csvUploaded
                              ? PricingDetails[0]?.BSP
                                ? numberWithCommas(
                                  PricingDetails[0]?.BSP +
                                  PricingDetails[0]?.BSP
                                )
                                : '-'
                              : PricingDetails[0]?.BSPTotal
                                ? numberWithCommas(
                                  PricingDetails[0]?.BSPTotal +
                                  PricingDetails[0]?.BSPTotal
                                )
                                : '-'}
                          </Box>
                        ) : (
                          <Box className={cssClasses.headerTitle1} mt={1}>
                            ₹{" "}
                            {csvUploaded
                              ? PricingDetails[0]?.BSP
                                ? numberWithCommas(PricingDetails[0]?.BSP)
                                : "-"
                              : PricingDetails[0]?.BSPTotal
                                ? numberWithCommas(PricingDetails[0]?.BSPTotal)
                                : '-'}
                          </Box>
                        )}
                      </Box>

                      <Box>
                        <Box className={cssClasses.subTitle}>GST:</Box>
                        {mergeIdData ? (
                          <Box className={cssClasses.headerTitle1} mt={1}>
                            ₹{" "}
                            {PricingDetails[0]?.GST
                              ? numberWithCommas(
                                PricingDetails[0]?.GST +
                                PricingDetails[0]?.GST
                              )
                              : '-'}
                          </Box>
                        ) : (
                          <Box className={cssClasses.headerTitle1} mt={1}>
                            ₹{" "}
                            {PricingDetails[0]?.GST ||
                              PricingDetails[0]?.GST === 0
                              ? numberWithCommas(PricingDetails[0]?.GST)
                              : "-"}
                          </Box>
                        )}
                      </Box>

                      <Box>
                        <Box className={cssClasses.subTitle}>SDR:</Box>
                        {mergeIdData ? (
                          <Box className={cssClasses.headerTitle1} mt={1}>
                            ₹{" "}
                            {PricingDetails[0]?.SDR
                              ? numberWithCommas(
                                PricingDetails[0]?.SDR +
                                PricingDetails[0]?.SDR
                              )
                              : '-'}
                          </Box>
                        ) : (
                          <Box className={cssClasses.headerTitle1} mt={1}>
                            ₹{" "}
                            {PricingDetails[0]?.SDR
                              ? numberWithCommas(PricingDetails[0]?.SDR)
                              : "-"}
                          </Box>
                        )}
                      </Box>

                      <Box>
                        <Box className={cssClasses.subTitle}>Total:</Box>
                        {mergeIdData ? (
                          <Box className={cssClasses.headerTitle1} mt={1}>
                            ₹
                            {/* removed && condition since we are not getting those value--- && FloorRiseValue && plcValue ,,,PricingDetails[0]?.BSPTotal + PricingDetails[0]?.GST  + PricingDetails[0]?.REG*/}
                            {csvUploaded
                              ? PricingDetails[0]?.totalCost
                                ? numberWithCommas(
                                  parseInt(PricingDetails[0]?.totalCost) +
                                  parseInt(PricingDetails[0]?.totalCost)
                                  // ! not to add floor rise & plc ==> vedashree changes
                                  // ! strictly do not uncomment
                                  // +
                                  // FloorRiseValue +
                                  // plcValue
                                )
                                : '-'
                              : PricingDetails[0]?.Total
                                ? numberWithCommas(
                                  parseInt(PricingDetails[0]?.Total) +
                                  parseInt(PricingDetails[0]?.Total)
                                  // +
                                  // FloorRiseValue +
                                  // plcValue
                                )
                                : '-'}
                          </Box>
                        ) : (
                          <Box className={cssClasses.headerTitle1} mt={1}>
                            ₹
                            {/* removed && ssince we are not getting those value----- && FloorRiseValue && plcValue ,,,PricingDetails[0]?.BSPTotal + PricingDetails[0]?.GST  + PricingDetails[0]?.REG*/}
                            {csvUploaded
                              ? PricingDetails[0]?.totalCost
                                ? numberWithCommas(
                                  // ! not to add floor rise & plc ==> vedashree changes
                                  // ! strictly do not uncomment
                                  // FloorRiseValue +
                                  // plcValue +
                                  parseInt(PricingDetails[0]?.totalCost)
                                )
                                : '-'
                              : PricingDetails[0]?.Total
                                ? numberWithCommas(
                                  // FloorRiseValue +
                                  // plcValue +
                                  parseInt(PricingDetails[0]?.Total)
                                )
                                : '-'}
                          </Box>
                        )}
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box ml={1.8}>
                        <Box className={cssClasses.subTitle}>Saleable Area of Unit:</Box>
                        <Box className={cssClasses.headerTitle1} mt={1}>
                          {saleableArea
                            ? numberWithCommas(saleableArea)
                            : "-"}{" "}
                          Sq.Ft.
                        </Box>
                      </Box>
                      <Box className={cssClasses.headerTitle1} ml={2} display={'flex'} flexDirection={'row'}>
                        <LeadStatusChip
                          style={{
                            color: "#000000",
                            backgroundColor: "#ececec",
                          }}
                          label={"Price not Added!"}
                          icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                        />
                        {afterCancelUnitPrice && (
                          <Box mt={0.2} ml={1}>
                            <InfoOutlinedIcon
                              onClick={handleClick}
                              style={{
                                width: '2rem',
                                height: '2rem',
                                color: '#344054',
                              }}
                            ></InfoOutlinedIcon>
                            <Popover
                              id={id}
                              open={IconOpen}
                              anchorEl={anchorEl}
                              onClose={handleIconClose}
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                              }}
                            >
                              <Typography
                                style={{ fontSize: '1.4rem' }}
                                sx={{ p: 2 }}
                              >
                                Unit is recently cancelled.Reprice is pending
                              </Typography>
                            </Popover>
                          </Box>
                        )}
                      </Box>
                    </>
                  )}
                </Box>

                {ProjectData[0]?.enablePaymentPlan && listOfProjectPaymentPlan.length > 0 && (
                  <Box className={cssClasses.wrapperDropDown} padding={"2rem"} width={"60rem"}>
                    <div className={cssClasses.SubHeader}>
                      Select Payment Plan
                    </div>
                    <div style={{ width: '60%' }}>
                      <DropDown
                        list={listOfProjectPaymentPlan.map((element, id) => {
                          return {
                            label: element.title,
                            value: element.title,
                          };
                        })}
                        selectedValue={selectedProjectPaymentPlanId}
                        onChangeSelect={(value) => {
                          setSelectedProjectPaymentPlanId(value);
                          let selectedProjectPricing =
                            listOfProjectPaymentPlan.filter(
                              (el) => value === el.title
                            );
                          setSelectedProjectPaymentPlan(
                            selectedProjectPricing[0]
                          );
                          presentLoader()
                          if(selectedProjectPricing[0]?.title === 'none'){
                            checkForInventoryStatus(unitNo).then(resp => {
                              const payload = [...PricingDetails]
                               payload[0].BSP = resp?.data?.BSP
                               payload[0].GST = resp?.data?.GST
                               payload[0].SDR = resp?.data?.SDR
                               payload[0].totalCost = resp?.data?.totalCost
                               setPricingDetails(payload)
                               dismissLoader()
                            }).catch(err => {
                              dismissLoader()
                            })
                          }else{
                          getPaymentPlansPriceFromServer(selectedProjectPricing[0]?.paymentPlanId,unitNo).then((resp) => {
                            if(resp?.data?.length > 0){
                               const payload = [...PricingDetails]
                               payload[0].BSP = resp?.data[0]?.BSP
                               payload[0].GST = resp?.data[0]?.GST
                               payload[0].SDR = resp?.data[0]?.SDR
                               payload[0].totalCost = resp?.data[0]?.totalCost
                               setPricingDetails(payload)
                               dismissLoader()
                            }else{
                              checkForInventoryStatus(unitNo).then(resp => {
                                const payload = [...PricingDetails]
                                 payload[0].BSP = resp?.data?.BSP
                                 payload[0].GST = resp?.data?.GST
                                 payload[0].SDR = resp?.data?.SDR
                                 payload[0].totalCost = resp?.data?.totalCost
                                 setPricingDetails(payload)
                                 dismissLoader()
                              }).catch(err => {
                                dismissLoader()
                              })
                            }
                          }).catch(err => {
                            dismissLoader()
                          })
                        }
                        }}
                        placeHolder={'Select Payment Plan'}
                        style={{
                          background: '#F2F4F7',
                          color: 'rgb(102, 112, 133)',
                        }}
                      />
                    </div>
                  </Box>
                )}

                <Box className={cssClasses.SearchDiv} style={{ height: '90%' }}>
                  <Box style={{ width: '50%' }}>
                    {globalLead === false && (
                      <Box margin={"2rem"}>
                        <Box
                          className={cssClasses.headerTitle}
                          marginBottom={"2.4rem"}
                        >
                          Lead Details
                        </Box>
                        {OnHoldData === true && (
                          <Box>
                            <Box
                              className={cssClasses.DetailsDiv}
                              margin={"3rem 0rem"}
                            >
                              <Box className={cssClasses.SearchDiv}>
                                <Box>
                                  <Box className={cssClasses.NameTitle}>
                                    {OnHoldDetails[0]?.Name}
                                  </Box>
                                  <Box className={cssClasses.NoTitle}>
                                    VJ
                                    {OnHoldDetails[0]?.DisplayId}
                                  </Box>
                                  {loggedInUser.roleId.level === 1 && (
                                    <>
                                      <Box
                                        className={cssClasses.PhoneNumberTitle}
                                        mt={1}
                                      >
                                        +{OnHoldDetails[0]?.MobileNumber}
                                      </Box>
                                      <Box className={cssClasses.PhoneNumberTitle}>
                                        {OnHoldDetails[0]?.Email}
                                      </Box>
                                    </>
                                  )}

                                </Box>
                              </Box>
                            </Box>
                            <Box>
                              <Box
                                className={cssClasses.headerTitle}
                                marginBottom={"2.4rem"}
                              >
                                VJ SM
                              </Box>
                              <Box
                                className={cssClasses.DetailsDiv}
                                margin={"3rem 0rem"}
                              >
                                <Box className={cssClasses.NameTitle}>
                                  {/* {AllotmentIdData[0]?.userId?.name} */}
                                  {AllotmentIdData[0]?.leadId?.userId?.name}
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        )}
                        {!OnHoldData && (
                          <Box className={cssClasses.SearchDiv}>
                            <Box className={cssClasses.InputDiv}>
                              <Box className={cssClasses.subTitle}>
                                Lead ID or Name
                              </Box>
                              <Box width={"35rem"}>
                                <CustomAutoComplete
                                  value={LeadValue}
                                  InitialValue={setLeadValue}
                                  SecondInputValue={LeadName}
                                  OnInputChange={(e, inputValue) => {
                                    setAllotmentData((pre) => {
                                      pre.displayName = inputValue;
                                      SearchDataInLeads(inputValue);
                                      return { ...pre };
                                    });

                                    if (AllotmentData.displayName !== "") {
                                      helperText.displayName = "";
                                    } else {
                                      helperText.displayName =
                                        "Please select Lead";
                                    }
                                  }}
                                  disable={NotForSaleChip === true}
                                  list={AllLeads.map((m) => ({
                                    label: `${m.LeadName} - ${m.LeadDisplayId}`,
                                  }))}
                                  NoOptionsText={"No Leads Found"}
                                  getOptionLabel={(lead) => lead.label || ""}
                                  renderOption={(props, SecondInputValue) => (
                                    <Fragment>
                                      <li {...props} key={SecondInputValue.id}>
                                        <span
                                          className={cssClasses.textWrapper}
                                          style={{
                                            overflow: "hidden",
                                            whiteSpace: "break-spaces",
                                          }}
                                        >
                                          {SecondInputValue.label}
                                        </span>
                                      </li>
                                    </Fragment>
                                  )}
                                  helperText={helperText.displayName}
                                />
                              </Box>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    )}

                    {globalLead === true && (
                      <Box marginTop={"7.5rem"}>
                        <Box margin={"2rem"}>
                          <Box
                            className={cssClasses.headerTitle}
                            marginBottom={"2.4rem"}
                          >
                            Lead Details
                          </Box>
                        </Box>
                        {LeadData?.map((lead, index) => (
                          <Box
                            className={cssClasses.DetailsDiv}
                            margin={"2rem"}
                          >
                            <Box className={cssClasses.SearchDiv}>
                              <Box>
                                <Box className={cssClasses.NameTitle}>
                                  {lead.LeadName}
                                </Box>
                                <Box className={cssClasses.NoTitle}>
                                  VJ
                                  {lead.LeadDisplayId}
                                </Box>
                                {loggedInUser.roleId.level === 1 && (
                                  <>
                                    <Box
                                      className={cssClasses.PhoneNumberTitle}
                                      mt={1}
                                    >
                                      +{lead.LeadMobileNumber}
                                    </Box>
                                    <Box className={cssClasses.PhoneNumberTitle}>
                                      {lead.LeadEmail}
                                    </Box>
                                  </>
                                )}

                              </Box>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )}
                    {/* Sarita's Adding adjust Unit Amount Starts Here*/}
                    {globalLead === true &&
                      getAlotSustenanceLead()?.oldAllotmentData &&
                      ProjectPricingDetails[0]?.inventoryStatusId?.status === 'Available' &&
                      (
                        <Box marginTop={"7.5rem"} className={cssClasses.wrapperSummary}>
                          <Box margin={"2rem"}>
                            <Box
                              className={cssClasses.headerTitle}
                              marginBottom={"2.4rem"}
                            >
                              Summary
                            </Box>
                          </Box>
                          <Box m={2} className={cssClasses.wrapperEachDiv}>
                            <div>
                              <div className={cssClasses.PhoneNumberTitle} style={{
                                fontFamily: 'Inter-Medium',
                                lineHeight: '1.8rem',
                                textAlign: 'left',
                                color: '#1D2939',
                                fontWeight: '600',
                                marginBottom: '0.5rem'
                              }}>
                                {getAlotSustenanceLead()?.oldAllotmentData?.projectname},{getAlotSustenanceLead()?.oldAllotmentData?.displaywingname ? getAlotSustenanceLead()?.oldAllotmentData?.displaywingname : getAlotSustenanceLead()?.oldAllotmentData?.wingname}-{getAlotSustenanceLead()?.oldAllotmentData?.unitno}
                              </div>
                              <div style={{
                                fontSize: '1.6rem',
                                fontFamily: 'Inter-Medium',
                                lineHeight: '2.4rem',
                                width: '50%',
                                textAlign: 'left',
                                color: '#344054',
                                display: 'flex',
                                justifyContent: 'space-between'
                              }}>
                                <span>Balance Amount:</span>
                                <span style={{ color: '#374151' }}>
                                  ₹
                                  {numberWithCommas(
                                    getAlotSustenanceLead()?.oldAllotmentData
                                      ?.paidamount
                                  )}
                                </span>

                              </div>
                            </div>
                            {/* <div  className={cssClasses.PhoneNumberTitle}>New Amount: */}
                            {BookingAmountData[0]?.TOTAL && (
                              <Box
                                className={cssClasses.PhoneNumberTitle}
                                mt={1}
                              >
                                <div className={cssClasses.PhoneNumberTitle} style={{
                                  fontFamily: 'Inter-Medium',
                                  lineHeight: '1.8rem',
                                  textAlign: 'left',
                                  color: '#1D2939',
                                  fontWeight: '600',
                                  marginBottom: '0.5rem'
                                }}>
                                  {/* {ProjectData[0]?.projectName},{UnitData[0]?.wingId?.wingName}-{UnitData[0]?.unitNo} */}
                                  {ProjectData[0]?.projectName},{UnitData[0]?.wingId?.displayName ? UnitData[0]?.wingId?.displayName : UnitData[0]?.wingId?.wingName}-{UnitData[0]?.unitNo}
                                </div>
                                <div style={{
                                  fontSize: '1.6rem',
                                  fontFamily: 'Inter-Medium',
                                  lineHeight: '2.4rem',
                                  width: '50%',
                                  textAlign: 'left',
                                  color: '#344054',
                                  display: 'flex',
                                  justifyContent: 'space-between'
                                }}>
                                  <span>Booking Amount:</span>
                                  <span style={{ color: '#374151' }}>
                                    ₹
                                    {numberWithCommas(BookingAmountData[0]?.TOTAL)}
                                  </span>

                                </div>

                              </Box>
                            )}

                            {/* </div> */}
                            {/* {getAlotSustenanceLead()?.oldAllotmentData?.paidamount<=BookingAmountData[0]?.TOTAL && (
                                <div
                                  className={cssClasses.PhoneNumberTitle}
                                  style={{ marginTop: "1rem" }}
                                >
                                  Difference Amount: ₹
                                  {numberWithCommas(BookingAmountData[0]?.TOTAL -getAlotSustenanceLead()?.oldAllotmentData?.paidamount)
                                  }
                                </div>
                              )} */}

                            {(getAlotSustenanceLead()?.oldAllotmentData
                              ?.updatedunitprice?.cancellationCharges !== 0 ||
                              getAlotSustenanceLead()?.oldAllotmentData
                                ?.updatedunitprice != null) && (
                                <div
                                  className={cssClasses.PhoneNumberTitle}
                                  // style={{ marginTop: "1rem" }}
                                  style={{
                                    fontSize: '1.6rem',
                                    fontFamily: 'Inter-Medium',
                                    lineHeight: '2.4rem',
                                    width: '50%',
                                    textAlign: 'left',
                                    color: '#344054',
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                  }}
                                >
                                  <span>Cancellation Charges:</span>
                                  <span style={{ color: '#374151' }}>
                                    ₹
                                    {getAlotSustenanceLead()?.oldAllotmentData
                                      ?.updatedunitprice?.cancellationCharges !==
                                      0
                                      ? numberWithCommas(getAlotSustenanceLead()?.oldAllotmentData?.updatedunitprice?.cancellationCharges)
                                      : 0}
                                  </span>
                                </div>
                              )}
                            {getAlotSustenanceLead()?.oldAllotmentData?.paidamount <= BookingAmountData[0]?.TOTAL ? (
                              <div
                                className={cssClasses.PhoneNumberTitle}
                                // style={{ marginTop: "1rem" }}
                                style={{
                                  fontSize: '1.6rem',
                                  fontFamily: 'Inter-Medium',
                                  lineHeight: '2.4rem',
                                  width: '50%',
                                  textAlign: 'left',
                                  color: '#344054',
                                  display: 'flex',
                                  justifyContent: 'space-between'
                                }}
                              >
                                Amount to be Paid:₹
                                {numberWithCommas(BookingAmountData[0]?.TOTAL - (getAlotSustenanceLead()?.oldAllotmentData?.paidamount - (getAlotSustenanceLead()?.oldAllotmentData?.updatedunitprice?.cancellationCharges ? getAlotSustenanceLead()?.oldAllotmentData?.updatedunitprice?.cancellationCharges : 0))
                                  )}
                              </div>
                            )
                              :
                              <><div className={cssClasses.PhoneNumberTitle}
                                style={{
                                  fontFamily: 'Inter-Medium',
                                  lineHeight: '1.4rem',
                                  textAlign: 'left',
                                  color: '#344054',
                                  marginBottom: '0.5rem'
                                }}> Amount to be Paid:₹0</div>
                                <div className={cssClasses.PhoneNumberTitle} style={{ marginTop: "1rem" }}>
                                  Note: Excess Amount to be adjusted in UnitCost

                                </div></>
                            }
                          </Box>
                        </Box>
                      )}
                    {globalLead === true &&
                      ProjectPricingDetails[0]?.inventoryStatusId?.status === 'Available' &&
                      errorMessageForAlotUnitAlreadyAlloted !== "" && (
                        <div
                          style={{ color: "red" }}
                          className={cssClasses.PhoneNumberTitle}
                        >
                          {errorMessageForAlotUnitAlreadyAlloted}
                        </div>
                      )}
                    {/* Sarita's Adding adjust Unit Amount Ends Here*/}

                    {AllotmentData.displayName !== "" &&
                      globalLead === false && OnHoldData === false && (
                        <Box>
                          {SameUser === false && (
                            <>
                              {LeadData?.map((lead, index) => (
                                <Box
                                  className={cssClasses.DetailsDiv}
                                  margin={"2rem"}
                                >
                                  <Box className={cssClasses.SearchDiv}>
                                    <Box>
                                      <Box className={cssClasses.NameTitle}>
                                        {lead.LeadName}
                                      </Box>
                                      <Box className={cssClasses.NoTitle}>
                                        VJ
                                        {lead.LeadDisplayId}
                                      </Box>
                                      {loggedInUser.roleId.level === 1 && (
                                        <>
                                          <Box
                                            className={cssClasses.PhoneNumberTitle}
                                            mt={1}
                                          >
                                            +{lead.LeadMobileNumber}
                                          </Box>
                                          <Box
                                            className={cssClasses.PhoneNumberTitle}
                                          >
                                            {lead.LeadEmail}
                                          </Box>
                                        </>
                                      )}

                                      {lead.siteVisitDone.length <= 0 && (
                                        <Box
                                          className={
                                            cssClasses.PhoneNumberTitle
                                          }
                                        >
                                          <LeadStatusChip
                                            style={{
                                              color: "#B42318",
                                              backgroundColor: "#FEE4E2",
                                            }}
                                            label={"Site Visit Not Done"}
                                            icon={
                                              <Dot
                                                width={"0.6rem"}
                                                height={"0.6rem"}
                                              />
                                            }
                                          />
                                        </Box>
                                      )}
                                    </Box>
                                  </Box>
                                </Box>
                              ))}
                            </>
                          )}
                        </Box>
                      )}

                    {DisabledInterest === false && (
                      <Box width={"fit-content"} margin={"2rem"}>
                        <Button
                          style={{
                            color: "#fff",
                            backgroundColor: "#1570EF",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                            fontFamily: "Roboto-Regular",
                          }}
                          padding={"0.8rem 1.8rem"}
                          btnName={"Show Interest"}
                          clicked={ShowInterestByLeadName}
                        />
                      </Box>
                    )}
                  </Box>

                  {/* {InterestQueueTable === true && (
                    <Box style={{ height: "100%", width: "50%" }}>
                      <Box style={{ width: "95%", height: "100%" }}>
                        <Box
                          className={cssClasses.subTitle}
                          marginTop={"7.5rem"}
                        >
                          Interest Queue for {UnitData[0]?.unitNo}
                        </Box>
                        <Box className={cssClasses.GridWrapper}>
                          <Datagrid
                            rows={UnitInterestData}
                            columns={ProjectColumns}
                            hideFooter={false}
                          />
                        </Box>
                      </Box>
                    </Box>
                  )} */}
                </Box>
              </Box>
            </>
          </Box>

          {UnitData[0]?.inventoryStatusId.status === "Available" &&
            !NotForSaleChip &&
            priceNotAdded === false &&
            (PricingDetails[0]?.BSP || PricingDetails[0]?.BSPTotal) &&
            (PricingDetails[0]?.SDR || PricingDetails[0]?.SDR === 0) &&
            (PricingDetails[0]?.GST || PricingDetails[0]?.GST === 0) &&
            (PricingDetails[0]?.Total || PricingDetails[0]?.totalCost) && (
              <>
                <Box className={cssClasses.footerDiv}>
                  <Box className={cssClasses.LeftButtonWrap}></Box>

                  <Box className={cssClasses.RightButtonWrap}>
                    {SameUser === false && (
                      <Button
                        style={{
                          color: "#fff",
                          backgroundColor: "#1570EF",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                          fontFamily: "Roboto-Regular",
                        }}
                        padding={'0.8rem 2.6rem'}
                        disable={paymentDetailsButton}
                        btnName={'Confirm'}
                        clicked={() => PaymentDetails()}
                      />
                    )}

                    {SameUser && (
                      <Box width={"fit-Content"}>
                        <Button
                          style={{
                            color: "#fff",
                            backgroundColor: "#1570EF",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                            fontFamily: "Roboto-Regular",
                          }}
                          //  disable={unitStatus === ''}
                          padding={"0.65rem 2.5rem"}
                          btnName={"Pay Now"}
                          clicked={() => setOpenPaymentModal(true)}
                        />
                      </Box>
                    )}
                  </Box>
                </Box>
              </>
            )}

          <Modal
            open={open}
            onClose={(_, reason) => {
              if (reason !== "backdropClick") {
                handleClose();
              }
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Box className={cssClasses.headerDiv}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.flexCol}>
                    <Box className={cssClasses.headerTitle}>Hold Unit</Box>{" "}
                  </Box>
                  <Box
                    ml={"auto"}
                    mt={1}
                    onClick={handleClose}
                    style={{ cursor: "pointer" }}
                  >
                    <Close width={"1.2rem"} height={"1.2rem"} />
                  </Box>
                </Box>
              </Box>

              <Box className={cssClasses.MiddleDiv}>
                <Box className={cssClasses.PhoneNumberTitle}>
                  Are you sure, you want to hold unit{" "}
                  {/* {UnitData[0]?.wingId?.wingName
                    ? UnitData[0]?.wingId?.wingName
                    : "-"} */}
                  {UnitData[0]?.wingId?.displayName ? UnitData[0]?.wingId?.displayName : UnitData[0]?.wingId?.wingName
                    ? UnitData[0]?.wingId?.wingName
                    : "-"}
                  -{UnitData[0]?.unitNo ? UnitData[0]?.unitNo : "-"} for{" "}
                  {SelectedLeadName} (VJ{SelectedLeadDisplayId}) ?
                </Box>
                {/* {listOfProjectPaymentPlan.length > 0 && (
                  <Box className={cssClasses.wrapperDropDown}>
                    <div className={cssClasses.SubHeader}>
                      Select Payment Plan
                    </div>
                    <div style={{ width: "60%" }}>
                      <DropDown
                        list={listOfProjectPaymentPlan.map((element, id) => {
                          return {
                            label: element.paymentPlanId.key,
                            value: element.paymentPlanId.key,
                          };
                        })}
                        selectedValue={selectedProjectPaymentPlanId}
                        onChangeSelect={(value) => {
                          setSelectedProjectPaymentPlanId(value);
                          let selectedProjectPricing =
                            listOfProjectPaymentPlan.filter(
                              (el) => value === el.paymentPlanId.key
                            );
                          setSelectedProjectPaymentPlan(
                            selectedProjectPricing[0]
                          );
                        }}
                        placeHolder={"Select Payment Plan"}
                        style={{
                          background: "#F2F4F7",
                          color: "rgb(102, 112, 133)",
                        }}
                      />
                    </div>
                  </Box>
                )} */}
              </Box>
              {/* Sarita Added DropDown for payment Plan  */}

              <Box className={cssClasses.FooterDiv}>
                <Box className={cssClasses.flexRow}>
                  <Box width={"fit-Content"} ml={"auto"}>
                    <Button
                      style={{
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        color: "#344054",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "0.8rem",
                      }}
                      padding={"0.85rem 2.6rem"}
                      btnName={"Exit"}
                      clicked={handleClose}
                    />
                  </Box>
                  {getAlotSustenanceLead()?.oldAllotmentData
                    ? Object.keys(getAlotSustenanceLead()?.oldAllotmentData)
                      .length === 0 ||
                    Object.keys(getAlotSustenanceLead()?.oldAllotmentData)
                      .length === null
                    : true && (
                      <Box width={"fit-Content"}>
                        <Button
                          style={{
                            color: "#fff",
                            backgroundColor: "#1570EF",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                            fontFamily: "Roboto-Regular",
                          }}
                          padding={"0.65rem 2.5rem"}
                          btnName={"Hold & Exit"}
                          clicked={() => OnSubmit("Hold & Exit")}
                        />
                      </Box>
                    )}
                  <Box width={"fit-Content"}>
                    <Button
                      style={{
                        color: "#fff",
                        backgroundColor: "#1570EF",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        fontFamily: "Roboto-Regular",
                      }}
                      //  disable={unitStatus === ''}
                      padding={"0.65rem 2.5rem"}
                      btnName={"Hold & Continue"}
                      clicked={() => OnSubmit("Hold & Continue")}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Modal>
        </>
      )}

      {isLoading && (
        <LoaderWithMsg isLoading={isLoading} loaderMsg={loaderMsg} />
      )}

      {openPaymentModal && (
        <div style={{ height: "100%", padding: "3rem" }}>
          <PaymentModal
            allotment={AllotmentIdData[0]}
            desk={"salesManagerDeskPaymentModes"}
            setOpenPaymentModal={setOpenPaymentModal}
          />
        </div>
      )}
    </>
  );
}

export default DirectAllotment;
